import apiClient from '../../core/apiClient';
import { ContractSummaryResponse } from '../../types/api';

export const contractsService = {
  getContractsSummary: async () => {
    const response = await apiClient.get<ContractSummaryResponse>('/api/contracts/summary');
    return response.data;
  },
  getContracts: async () => {
    const response = await apiClient.get('/api/contracts/list');
    return response.data;
  },
  getContractDetails: async (id: string) => {
    const response = await apiClient.get(`/api/contracts/${id}`);
    return response.data;
  }
};
